import { environment } from "@environment"

const iconpaths = "./../../../../../../assets/landing-investments"
export const BTNS_INVERTIR =  [
    {
        id: 'invertir-no-apv',
        icon: iconpaths + '/invertir_ffmm.svg',
        title: 'Invertir en Fondos Mutuos Régimen Normal',
        description: 'Invierte en nuestra amplia oferta de FFMM nacionales e internacionales.',
        btnName: 'Invertir',
        activo: true
    },
    {
        id: 'invertir-apv',
        icon: iconpaths + '/invertir_apv.svg',
        title: 'Invertir en Fondos Mutuos APV',
        description: 'Accede a beneficios tributarios y aportes del Estado para favorecer los ahorros.',
        btnName: 'Invertir',
        activo: true
    },
    {
        id: 'ingreso-ordenes-bolsa',
        icon: iconpaths + '/account_balance.svg',
        title: 'Ingreso de órdenes Plataforma nacional',
        description: 'Ingresa órdenes de compra y venta de acciones locales, FIR, ETF y Fondos de Inversión a la Corredora de Bolsa.',
        btnName: 'Ingresar',
        activo: true
    },
    {
        id: 'ingreso-ordenes-divisas',
        icon: iconpaths + '/icon-fx.svg',
        title: 'Ingreso de órdenes de compra/venta de divisas',
        description: 'Ingresa órdenes de compra y venta de divisas.',
        activo: true,
        btnName: 'Ingresar'
    },
    {
        id: 'pershing-selector-cuenta',
        icon: iconpaths + '/account_balance.svg',
        title: 'Ingreso de órdenes Plataforma extranjera',
        description: 'Ingresa cambio de fondos, inversión y/o rescates de instrumentos internacionales (Pershing LLC).',
        activo: true,
        btnName: 'Ingresar'
    },
    {
        id: 'forward',
        icon: iconpaths + '/invertir_forward.svg',
        title: 'Ingreso de ordenes Forward',
        description: 'Ingresa órdenes forward, acordando precio y fecha futura de operación.',
        activo: true,
        btnName: 'Ingresar'
    },
]

export const URL_INGRESO_ORDENES_FWD = "https://nam02.safelinks.protection.outlook.com/?url=https%3A%2F%2Fapps.powerapps.com%2Fplay%2Fe%2F66ddbef8-4a58-eac1-9b83-ce3c72cd8fe6%2Fa%2F9c58f997-d509-4200-bc4f-ef88d09a5291%3FtenantId%3D2cb4d124-c9ed-48cc-aefd-228cd153e897%26hint%3D9f4e63f3-ffc1-41d9-b9f1-04e723c577a2%26source%3Dsharebutton%26sourcetime%3D1780351971617&data=05%7C02%7CRaul.Luna%40surainvestments.com%7Cd14af080e2be4c72734e08dec02b45a9%7C2cb4d124c9ed48ccaefd228cd153e897%7C0%7C0%7C639159490013339267%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=QB%2FfC0Yf3BWbaRVJ0YxMQ%2FkbYJH3AoQmMK4XSInDYcA%3D&reserved=0"
